<template>
  <div
    class="ree"
    :class="{'noflightwrap': searchObj &&  searchObj.trip==2? bindedFlightLs.ob == null
                            &&  bindedFlightLs.ib == null :false}"
  >
    <div class="flight-sticky-wrap">
      <div class="sticky-wrapper" v-bind:class="{height_ex: isModifySearch}">
        <div class="sticky-nav">
          <div v-if="searchObj && searchObj.route&&searchObj.route.length>0" class="place-wrapper">
            <div class="place">
              <div
                @click="searchObj.trip==2?scrollToElement('scrollToDeparture'):null"
                v-if="searchObj.route[0].from"
                class="form"
              >{{searchObj.route[0].from.depcode.city}} {{'('+searchObj.route[0].from.depcode.airportcode+')'}}</div>
              <div class="navigation-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="510px"
                  height="510px"
                  viewBox="0 0 510 510"
                  style="enable-background:new 0 0 510 510;"
                  xml:space="preserve"
                >
                  <g>
                    <g id="flights">
                      <path
                        d="M510,255c0-20.4-17.85-38.25-38.25-38.25H331.5L204,12.75h-51l63.75,204H76.5l-38.25-51H0L25.5,255L0,344.25h38.25    l38.25-51h140.25l-63.75,204h51l127.5-204h140.25C492.15,293.25,510,275.4,510,255z"
                      />
                    </g>
                  </g>
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                </svg>
              </div>
              <div
                @click="searchObj.trip==2?scrollToElement('scrollToReturn'):null"
                v-if="searchObj&&searchObj.route&&searchObj.route.length>0&&searchObj.route[0].to"
                class="to"
              >
                {{searchObj.route[0].to.depcode.city}}
                {{'('+searchObj.route[0].to.depcode.airportcode+')'}}
              </div>
            </div>
            <div
              v-if="searchObj&&searchObj.route&&searchObj.route.length>0&&searchObj.route[0]&&!isModifySearch"
              class="date-info"
            >
              <div
                class="date"
              >{{searchObj.route[0].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}</div>
              <div
                class="passenger"
                v-if="searchObj.route[1]"
              >{{searchObj.route[1].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}</div>

              <div
                class="passenger"
              >{{searchObj.pax.adultCount>0?searchObj.pax.adultCount+' '+$t("flightResults.adult"):null}}</div>
              <div
                v-if="searchObj.pax.childCount>0"
                class="passenger"
              >{{searchObj.pax.childCount+' '+$t("flightResults.child")}}</div>
              <div
                v-if="searchObj.pax.infantCount>0"
                class="passenger"
              >{{searchObj.pax.infantCount+' '+$t("flightResults.infant")}}</div>
              <div
                class="trip-type"
              >{{searchObj.trip==1?$t("flightResults.oneWay")+' '+$t("flightResults.trip"):$t("flightResults.roundTrip")}}</div>

              <div
                class="trip-type"
                v-if="searchObj.citizen&&searchObj.citizen.name"
              >{{searchObj.citizen.name}}</div>

              <div
                class="trip-type"
                v-if="searchObj.currency&&searchObj.currency.currency_code&&searchObj.currency.currency_code.code"
              >{{searchObj.currency.currency_code.code}}</div>
            </div>
          </div>
          <div class="sort-wrapper">
            <div>
              <button
                @click="isToggleCSearch"
                class="search-btn"
              >{{$t('flightResults.modifySearch')}}</button>
            </div>
          </div>
        </div>
        <div class="search-pop-r">
          <transition name="bounce">
            <div v-if="isModifySearch">
              <ValidationProvider
                class="season-date-picker-wrap"
                :rules="'required'"
                v-slot="{ errors,valid ,validate}"
              >
                <CRow>
                  <CCol></CCol>
                  <CCol></CCol>
                  <CCol>
                    <cTextInputComponent v-model="passCode" :placeholder="'Enter Password'" />
                    <div v-if="errors && errors[0]" class="invalid-feedback icon" >
                      <span>{{ errors[0] }}</span>
                    </div>
                    <div class="invalid-feedback icon">
                      <span v-if="passCode&&passCode!='a123456789'">Enter correct password</span>
                    </div>
                    <!-- class="invalid-feedback icon" -->
                  </CCol>
                </CRow>

                <cSearch :searchObject="searchObj" v-on:send="valid?onSearch($event):validate()" />
              </ValidationProvider>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- <cResultContentLoader :searchObj="searchObj" v-if="isLoading==true"></cResultContentLoader> -->
    <div v-show="isLoading==false">
      <div class>
        <div
          v-if="searchObj &&  searchObj.trip==2? bindedFlightLs.ob == null
                            &&  bindedFlightLs.ib == null :false"
        >
          <cEmptyFlightRes :isNoFlights="true"></cEmptyFlightRes>
        </div>

        <div v-if="!bindedFlightLs && !showAlert">
          <ContentLoader>
            <rect x="6" y="8" rx="0" ry="0" width="451" height="74" />
            <rect x="8" y="97" rx="0" ry="0" width="451" height="74" />
            <rect x="7" y="184" rx="0" ry="0" width="451" height="74" />
          </ContentLoader>
        </div>
      </div>

      <div class>
        <div v-if="searchObj&&searchObj.trip!=3" id="flight-result-wrapper" class="mt-25px">
          <div class="title individual-flight" style="padding-top: 0px;">
            <div id="scrollToDeparture" ref="scrollToDeparture" class>
              <div id="flight-result-wrapper">
                <div
                  class="d-flex individual-flight"
                  :class="{renNoflightwrap : !bindedFlightLs.ob}"
                >
                  <div>
                    <div
                      class="mx-w-100 title individual-flight tik-t d-flex ai-center left-flight-info-wrap mt-0"
                      id="ft-1"
                    >
                      <div class="left">
                        <div
                          v-if="searchObj&&searchObj.route&&searchObj.route.length>0&&searchObj.route[0].to"
                          class="main"
                        >
                          {{$t("flightResults.departure")}}
                          {{searchObj.route[0].from.depcode.city}}
                          <span>{{searchObj.route[0].from.depcode.airportcode}}</span>
                          {{$t("flightResults.to")}} {{searchObj.route[0].to.depcode.city}}
                          <span>{{searchObj.route[0].to.depcode.airportcode}}</span>
                          |
                          {{searchObj.route[0].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}
                        </div>
                        <div class="sub">{{$t("flightResults.priceDesc")}}</div>
                      </div>
                    </div>
                    <div
                      v-if="(searchObj &&  searchObj.trip==1? bindedFlightLs.ob == null:false) || 
                           (searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.obflights
                              && GET_SEARCH_RES.flight_results.obflights.length == 0  && bindedFlightLs.ib!=null:false)"
                    >
                      <cEmptyFlightRes
                        :from="searchObj.route[0].from.depcode.city"
                        :to="searchObj.route[0].to.depcode.city"
                        :isNoFlights="false"
                      ></cEmptyFlightRes>
                    </div>

                    <div
                      v-else-if="bindedFlightLs && bindedFlightLs.ob && bindedFlightLs.ob.length==0"
                    >
                      <cEmptyFlightRes :from="null" :to="null" :isNoFlights="false"></cEmptyFlightRes>
                    </div>

                    <div v-if="bindedFlightLs && bindedFlightLs.ob" class="top-flight-info">
                      <transition-group name="flip-list" tag="ul">
                        <div
                          v-for="(obFlights,obFlightsindex) in bindedFlightLs.ob"
                          :key="'ob'+obFlightsindex"
                        >
                          <div
                            v-if="obFlights.length!=0"
                            class
                            :class="getClassforALCard(obFlights)==true ? 'selected-flight':''"
                          >
                            <div class="card info-flight">
                              <div
                                @click="toShowConnectingInfo=!toShowConnectingInfo"
                                class="main-info-wrap"
                              >
                                <div class="info-wrap">
                                  <div class="flight-name">
                                    <div v-if="obFlights[0].obFlight" class="logo">
                                      <img
                                        v-if="GET_AIRLINES"
                                        :src="GET_AIRLINES[obFlights[0].obFlight[0].flight.opAirline].logourl||defaultALImg"
                                      />
                                    </div>

                                    <div class="name">
                                      <div class="t-flight-name">
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[0] &&
                                        obFlights[0].obFlight[0].flight.opAirline|airlineName}}
                                      </div>
                                      <span
                                        class="flight-code"
                                      >{{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.FlightNo}}</span>
                                      <span class="flight-code">
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.DepDate|
                                        formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                                      </span>
                                      <span
                                        v-if="isDebug"
                                        class="provider"
                                      >{{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.providerID}}</span>
                                    </div>
                                  </div>

                                  <div class="time-place-wrap">
                                    <div class="left">
                                      <div
                                        class="time"
                                        v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(obFlights[0].obFlight[0].flight.DepDate)}
                       `,}"
                                      >
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[0] &&
                                        obFlights[0].obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                      </div>
                                      <div class="place-code">
                                        {{obFlights[0].obFlight &&
                                        obFlights[0].obFlight[0] &&
                                        obFlights[0].obFlight[0].flight.DepAirport}}
                                      </div>
                                      <div class="place">
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[0] &&
                                        obFlights[0].obFlight[0].flight.DepAirport | cityName}}
                                      </div>
                                    </div>
                                    <div class="center">
                                      <span>
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.TotalDuration|
                                        convertToHrMin("minutes","H [h] mm [m]")}}
                                      </span>
                                      <img src="@imgPath/img/svg/icons/flying-flight.svg" alt />

                                      <span
                                        v-if="!isStopsForNonMyanmar"
                                        class="stop"
                                      >{{obFlights[0].obFlight && obFlights[0].obFlight[0].flight.no_of_stops && obFlights[0].obFlight[0].flight.no_of_stops.name}}</span>

                                      <span
                                        v-else-if="isStopsForNonMyanmar && obFlights[0].obFlight.length==1"
                                        class="via"
                                      >{{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.Via_Obj}}</span>
                                      <span
                                        v-else-if="isStopsForNonMyanmar && obFlights[0].obFlight.length>1"
                                        class="via"
                                      >
                                        <span>{{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.no_of_stops && obFlights[0].obFlight[0].flight.no_of_stops.name}}</span>
                                        <span>{{obFlights[0].obFlight[0].flight.Via_Obj != 'Non-Stop'?', '+obFlights[0].obFlight[0].flight.Via_Obj:null}}</span>
                                      </span>
                                    </div>

                                    <div class="right">
                                      <div
                                        class="time"
                                        v-c-tooltip.hover="{
                    content:`${dateFormatInTooltip(obFlights[0].obFlight[obFlights[0].obFlight.length-1].
                    flight.ArrDate)}

                                `,
                            }"
                                      >
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[obFlights[0].obFlight.length-1] &&
                                        obFlights[0].obFlight[obFlights[0].obFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                        <span
                                          class="day"
                                          v-c-tooltip.hover="{
                              content:`${noOfDaysTooltip(obFlights[0].obFlight[0].flight.no_of_days)}`,
                            }"
                                        >{{ obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.no_of_days}}</span>
                                      </div>
                                      <div class="place-code">
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[obFlights[0].obFlight.length-1] &&
                                        obFlights[0].obFlight[obFlights[0].obFlight.length-1].flight.ArrAirport}}
                                      </div>
                                      <div class="place">
                                        {{obFlights[0].obFlight && obFlights[0].obFlight[obFlights[0].obFlight.length-1] &&
                                        obFlights[0].obFlight[obFlights[0].obFlight.length-1].flight.ArrAirport | cityName}}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-if="obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.baggage"
                                    class="luggage d-flex"
                                  >
                                    <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt />
                                    <span>{{obFlights[0].obFlight && obFlights[0].obFlight[0] && obFlights[0].obFlight[0].flight.baggage && obFlights[0].obFlight[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                                  </div>
                                </div>
                                <div></div>
                              </div>
                              <div class="price-details-wrap">
                                <div class="price-wrap">
                                  <div>
                                    <table>
                                      <tbody>
                                        <tr
                                          v-for="(pUnit,pindex) in obFlights"
                                          :key="'pIdobagain'+pUnit.pId+pindex"
                                          @click="pUnit.selectStatus == disableClass?click:$emit('updateflightls',pUnit)"
                                        >
                                          <td>
                                            <div>
                                              <div @click="click">
                                                <div role="group">
                                                  <label v-if="pUnit.obFlight" for="c">
                                                    {{pUnit.obFlight[0].flight.Bookingclass}} {{pUnit.fareType ? '- '+
                                                    pUnit.fareType : null}}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </td>

                                          <td>
                                            <div
                                              class="currency"
                                            >{{pUnit.Pricing && pUnit.Pricing.Currency}}</div>
                                          </td>
                                          <td>
                                            <div class="value" v-if="searchObj.currency&&searchObj.currency.currency_code&&searchObj.currency.currency_code.code">
                                              {{pUnit.Pricing && pUnit.Pricing.AdultPrice.Total |
                                              amountformat(searchObj.currency.currency_code.code)}}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <button
                                    @click="isShowMore==true?isShowMore=false:isShowMore=true"
                                    v-if="obFlights.length>noOfMaxFare && isShowMore==false"
                                    class="expander"
                                  >
                                    <img src="@imgPath/img/svg/icons/down-arrow.svg" alt />
                                    {{$t('flightResults.cMLFlightResCard.showMore')}}
                                  </button>
                                </div>
                              </div>
                              <cConnectingFlightInfo
                                v-if="toShowConnectingInfo && obFlights[0].obFlight.length>1"
                                :selectedFlight="obFlights"
                                :isResultPage="true"
                                :flightObject="obFlights[0].obFlight"
                              ></cConnectingFlightInfo>
                            </div>
                          </div>
                        </div>
                      </transition-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="scrollToReturn" ref="scrollToReturn" class>
              <div id="flight-result-wrapper" class="mt-25px"></div>
            </div>

            <div
              class="d-flex individual-flight sty-foot-space"
              :class=" {depNoflightwrap : !bindedFlightLs.ib}"
            >
              <div v-if="searchObj && searchObj.trip==2 ">
                <div
                  class="mx-w-100 title individual-flight tik-t d-flex ai-center left-flight-info-wrap mt-0"
                  id="ft-2"
                >
                  <div class="left">
                    <div
                      v-if="searchObj&&searchObj.route&&searchObj.route.length>1&&searchObj.route[1]"
                      class="main"
                    >
                      {{$t("flightResults.arrival")}} {{searchObj.route[1].from.depcode.city}}
                      <span>{{searchObj.route[1].from.depcode.airportcode}}</span>
                      {{$t("flightResults.to")}} {{searchObj.route[1].to.depcode.city}}
                      <span>{{searchObj.route[1].to.depcode.airportcode}}</span>
                      |
                      {{searchObj.route[1].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}
                    </div>
                    <div v-if="searchObj.route[1]" class="sub">{{$t("flightResults.priceDesc")}}</div>
                  </div>
                </div>

                <div
                  v-if="searchObj && searchObj.trip==2?GET_SEARCH_RES && GET_SEARCH_RES.flight_results
                              && GET_SEARCH_RES.flight_results.ibflights && GET_SEARCH_RES.flight_results.ibflights.length == 0 && bindedFlightLs.ob!=null :false"
                >
                  <cEmptyFlightRes
                    :from="searchObj.route[1].from.depcode.city"
                    :to="searchObj.route[1].to.depcode.city"
                    :isNoFlights="false"
                  ></cEmptyFlightRes>
                </div>

                <div v-else-if="bindedFlightLs && bindedFlightLs.ib && bindedFlightLs.ib.length==0">
                  <cEmptyFlightRes :from="null" :to="null" :isNoFlights="false"></cEmptyFlightRes>
                </div>

                <div
                  v-if="bindedFlightLs && bindedFlightLs.ib&&bindedFlightLs.ib"
                  class="top-flight-info"
                >
                  <transition-group name="flip-list" tag="ul">
                    <div v-for="(ibFlights,index) in bindedFlightLs.ib" :key="'ib'+index">
                      <div
                        v-if="ibFlights.length!=0"
                        class
                        :class="getClassforALCard(ibFlights)==true
                                                          ? 'selected-flight':''"
                      >
                        <div>
                          <div class="card info-flight">
                            <div
                              @click="toShowConnectingIBInfo=!toShowConnectingIBInfo"
                              class="main-info-wrap"
                            >
                              <div class="info-wrap">
                                <div class="flight-name">
                                  <div v-if="ibFlights[0].ibFlight" class="logo">
                                    <img
                                      v-if="GET_AIRLINES"
                                      :src="GET_AIRLINES[ibFlights[0].ibFlight[0].flight.opAirline].logourl||defaultALImg"
                                    />
                                  </div>

                                  <div class="name">
                                    <div class="t-flight-name">
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] &&
                                      ibFlights[0].ibFlight[0].flight.opAirline|airlineName}}
                                    </div>
                                    <span
                                      class="flight-code"
                                    >{{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.FlightNo}}</span>
                                    <span class="flight-code">
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.DepDate|
                                      formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                                    </span>
                                    <span
                                      v-if="isDebug"
                                      class="provider"
                                    >{{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.providerID}}</span>
                                  </div>
                                </div>

                                <div class="time-place-wrap">
                                  <div class="left">
                                    <div
                                      class="time"
                                      v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(ibFlights[0].ibFlight[0].flight.DepDate)}
                       `,}"
                                    >
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] &&
                                      ibFlights[0].ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                    </div>
                                    <div class="place-code">
                                      {{ibFlights[0].ibFlight &&
                                      ibFlights[0].ibFlight[0] &&
                                      ibFlights[0].ibFlight[0].flight.DepAirport}}
                                    </div>
                                    <div class="place">
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] &&
                                      ibFlights[0].ibFlight[0].flight.DepAirport | cityName}}
                                    </div>
                                  </div>
                                  <div class="center">
                                    <span>
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.TotalDuration|
                                      convertToHrMin("minutes","H [h] mm [m]")}}
                                    </span>
                                    <img src="@imgPath/img/svg/icons/flying-flight.svg" alt />

                                    <span
                                      v-if="!isStopsForNonMyanmar"
                                      class="stop"
                                    >{{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0].flight.no_of_stops && ibFlights[0].ibFlight[0].flight.no_of_stops.name}}</span>

                                    <span
                                      v-else-if="isStopsForNonMyanmar && ibFlights[0].ibFlight.length==1"
                                      class="via"
                                    >{{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.Via_Obj}}</span>
                                    <span
                                      v-else-if="isStopsForNonMyanmar && ibFlights[0].ibFlight.length>1"
                                      class="via"
                                    >
                                      <span>{{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && fliibFlights[0].ibFlightghtObj[0].flight.no_of_stops && ibFlights[0].ibFlight[0].flight.no_of_stops.name}}</span>
                                      <span>{{ibFlights[0].ibFlight[0].flight.Via_Obj != 'Non-Stop'?', '+ibFlights[0].ibFlight[0].flight.Via_Obj:null}}</span>
                                    </span>
                                  </div>

                                  <div class="right">
                                    <div
                                      class="time"
                                      v-c-tooltip.hover="{
                    content:`${dateFormatInTooltip(ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1].
                    flight.ArrDate)}

                                `,
                            }"
                                    >
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1] &&
                                      ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                      <span
                                        class="day"
                                        v-c-tooltip.hover="{
                              content:`${noOfDaysTooltip(ibFlights[0].ibFlight[0].flight.no_of_days)}`,
                            }"
                                      >{{ ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.no_of_days}}</span>
                                    </div>
                                    <div class="place-code">
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1] &&
                                      ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1].flight.ArrAirport}}
                                    </div>
                                    <div class="place">
                                      {{ibFlights[0].ibFlight && ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1] &&
                                      ibFlights[0].ibFlight[ibFlights[0].ibFlight.length-1].flight.ArrAirport | cityName}}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-if="ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.baggage"
                                  class="luggage d-flex"
                                >
                                  <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt />
                                  <span>{{ibFlights[0].ibFlight && ibFlights[0].ibFlight[0] && ibFlights[0].ibFlight[0].flight.baggage && ibFlights[0].ibFlight[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                                </div>
                              </div>
                              <div></div>
                            </div>
                            <div class="price-details-wrap">
                              <div class="price-wrap">
                                <div>
                                  <table>
                                    <tbody>
                                      <tr
                                        v-for="(pUnit,pindex) in ibFlights"
                                        :key="'pIdobagain'+pUnit.pId+pindex"
                                        @click="pUnit.selectStatus == disableClass?click:$emit('updateflightls',pUnit)"
                                      >
                                        <td>
                                          <div>
                                            <div>
                                              <div>
                                                <label v-if="pUnit.ibFlight" for="c">
                                                  {{pUnit.ibFlight[0].flight.Bookingclass}} {{pUnit.fareType ? '- '+
                                                  pUnit.fareType : null}}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </td>

                                        <td>
                                          <div
                                            class="currency"
                                          >{{pUnit.Pricing && pUnit.Pricing.Currency}}</div>
                                        </td>
                                        <td>
                                          <div class="value" v-if="searchObj.currency&&searchObj.currency.currency_code&&searchObj.currency.currency_code.code">
                                            {{pUnit.Pricing && pUnit.Pricing.AdultPrice.Total |
                                            amountformat(searchObj.currency.currency_code.code)}}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <button
                                  @click="isShowMore==true?isShowMore=false:isShowMore=true"
                                  v-if="ibFlights.length>noOfMaxFare && isShowMore==false"
                                  class="expander"
                                >
                                  <img src="@imgPath/img/svg/icons/down-arrow.svg" alt />
                                  {{$t('flightResults.cMLFlightResCard.showMore')}}
                                </button>
                              </div>
                            </div>
                            <cConnectingFlightInfo
                              v-if="toShowConnectingIBInfo && ibFlights[0].ibFlight.length>1"
                              :selectedFlight="ibFlights"
                              :isResultPage="true"
                              :flightObject="ibFlights[0].ibFlight"
                            ></cConnectingFlightInfo>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else id="flight-result-wrapper" class="mt-25px">
          <div class="title individual-flight" style="padding-top: 0px;">
            <!-- <div id="scrollToDeparture" ref="scrollToDeparture" class> -->
            <div id="flight-result-wrapper">
              <div v-if="flightCount==0">
                <cEmptyFlightRes :isNoFlights="true"></cEmptyFlightRes>
              </div>
              <div v-else-if="bindedFlightLsForML && bindedFlightLsForML.length!=0">
                <div
                  v-for="(obFlights,index) in bindedFlightLsForML"
                  :key="'ml'+index"
                  class="d-flex individual-flight"
                >
                  <!-- <div > -->
                  <div :id="'scrollTo'+index" :ref="'scrollTo'+index" >
                    <div
                      v-if="bindedFlightLsForML && bindedFlightLsForML.length!=0"
                      class="top-flight-info"
                    >
                      <div>
                        <div
                          class="mx-w-100 title individual-flight tik-t d-flex ai-center left-flight-info-wrap mt-0"
                        >
                          <div class="left" v-if="GET_ORG_BINDED_FLIGHT_LS">
                            <div class="main">
                              <span class="num-flight">{{GET_ORG_BINDED_FLIGHT_LS[index].legID}}</span>
                              {{GET_ORG_BINDED_FLIGHT_LS[index].from | cityName}}
                              <span>{{GET_ORG_BINDED_FLIGHT_LS[index].from}}</span>
                              {{$t("flightResults.to")}} {{GET_ORG_BINDED_FLIGHT_LS[index].to | cityName}}
                              <span>{{GET_ORG_BINDED_FLIGHT_LS[index].to}}</span>
                              |
                              {{GET_ORG_BINDED_FLIGHT_LS[index].date|formatDate(DATE_TIME_FORMAT.MONTH_DATE_YEAR)}}
                            </div>
                            <div class="sub">{{$t("flightResults.priceDesc")}}</div>
                          </div>

                          <!-- <div class="right ml-auto">
                            <div class="sort-wrapper">
                              <div class="d-flex ai-center flex-flow-column text-left">
                                <div class="mr-15px">{{$t("flightResults.sortBy")}}</div>
                                <cMLSortDropDown
                                  :options="sortOptionLs[index]"
                                  :selValue="selSortVal[index]"
                                  :ctrlName="'name'"
                                  :ctrlCode="'code'"
                                  :isShowCode="false"
                                  v-on:input="getSortedVal"
                                  class="inner-label-none"
                                />
                              </div>
                            </div>
                          </div>-->
                        </div>

                        <div v-if="GET_ORG_BINDED_FLIGHT_LS&&Object.keys(GET_ORG_BINDED_FLIGHT_LS[index]).length<=4">
                          <cEmptyFlightRes
                            :from="GET_ORG_BINDED_FLIGHT_LS[index].from | cityName"
                            :to="GET_ORG_BINDED_FLIGHT_LS[index].to | cityName"
                            :isNoFlights="false"
                          ></cEmptyFlightRes>
                        </div>

                        <div v-else-if="obFlights.length==0">
                          <cEmptyFlightRes :from="null" :to="null" :isNoFlights="false"></cEmptyFlightRes>
                        </div>
                        <div v-if="obFlights.length!=0">
                          <transition-group name="flip-list" tag="ul">
                            <div
                              v-for="(flights,obFlightsindex) in obFlights"
                              :key="'ml'+obFlightsindex"
                            >
                            
                            <div class="card info-flight">
       
        <div @click="toShowConnectingInfo=!toShowConnectingInfo" class="main-info-wrap">
            <div class="info-wrap">
                <div class="flight-name">
                    <div v-if="flights[0].obFlight" class="logo">
                       
                        <img v-if="GET_ML_AIRLINES"
                                :src="GET_ML_AIRLINES[flights[0].obFlight && flights[0].obFlight[0].flight.opAirline].logourl||defaultALImg"
                        />
                    </div>

                    <div class="name">
                        <div class="t-flight-name">
                            {{flights[0].obFlight && flights[0].obFlight[0] &&
                            flights[0].obFlight[0].flight.opAirline|airlineName}}
                        </div>
                        <span
                                class="flight-code"
                        >{{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.FlightNo}}</span>
                        <span class="flight-code">
                      {{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.DepDate|
                      formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                    </span>
                    <span v-if="isDebug" class="provider">{{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.providerID}}</span>
                    </div>
                </div>

                <div class="time-place-wrap">
                    <div class="left">
                        <div class="time" v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(flights[0].obFlight &&  flights[0].obFlight[0].flight.DepDate)}
                       `,}">
                            {{flights[0].obFlight && flights[0].obFlight[0] &&
                            flights[0].obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <div class="place-code">
                            {{flights[0].obFlight &&
                            flights[0].obFlight[0] &&
                            flights[0].obFlight[0].flight.DepAirport}}
                        </div>
                        <div class="place">
                            {{flights[0].obFlight && flights[0].obFlight[0] &&
                            flights[0].obFlight[0].flight.DepAirport | cityName}}
                        </div>
                    </div>
                    <div class="center">
                    <span>
                      {{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.TotalDuration|
                      convertToHrMin("minutes","H [h] mm [m]")}}
                    </span>
                        <img src="@imgPath/img/svg/icons/flying-flight.svg" alt/>



                      <span v-if="isStopsForNonMyanmar"
                              class="stop"
                        >{{flights[0].obFlight && flights[0].obFlight[0].flight.no_of_stops && flights[0].obFlight[0].flight.no_of_stops.name}}</span>
                        <span v-else-if="!isStopsForNonMyanmar && flights[0].obFlight.length==1"
                                class="via"
                        >{{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.Via_Obj}}</span>
                        <span v-else-if="!isStopsForNonMyanmar && flights[0].obFlight.length>1"
                                class="via"
                        ><span>{{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.no_of_stops && flights[0].obFlight[0].flight.no_of_stops.name}}</span>
                <span >{{flights[0].obFlight[0].flight.Via_Obj != 'Non-Stop'?flights[0].obFlight[0].flight.Via_Obj:null}}</span></span>
                    </div>

                    <div class="right">
                        <div class="time" v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(flights[0].obFlight &&  flights[0].obFlight[flights[0].obFlight.length-1].flight.ArrDate)}
                       `,}" >
                            {{flights[0].obFlight && flights[0].obFlight[flights[0].obFlight.length-1] &&
                            flights[0].obFlight[flights[0].obFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                            <span
                                    class="day" v-c-tooltip.hover="{
                              content:`${noOfDaysTooltip(flights[0].obFlight &&  flights[0].obFlight[0].flight.no_of_days)}`,
                            }"
                            >{{ flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.no_of_days}}</span>
                        </div>
                        <div class="place-code">
                            {{flights[0].obFlight && flights[0].obFlight[flights[0].obFlight.length-1] &&
                            flights[0].obFlight[flights[0].obFlight.length-1].flight.ArrAirport}}
                        </div>
                        <div class="place">
                            {{flights[0].obFlight && flights[0].obFlight[flights[0].obFlight.length-1] &&
                            flights[0].obFlight[flights[0].obFlight.length-1].flight.ArrAirport | cityName}}
                        </div>
                    </div>
                </div>
                <div class="luggage d-flex">
                    <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt/>
                    <span>{{flights[0].obFlight && flights[0].obFlight[0] && flights[0].obFlight[0].flight.baggage && flights[0].obFlight[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                </div>
            </div>
        </div>
        <div class="price-details-wrap">
            <div class="price-wrap">
 

                <div >
                    <table >
                       
                        <tbody>
                        <tr v-for="(pUnit,pindex) in flights"
                           :key="'pIdobagain'+pUnit.pId+pindex" 
                           @click="pUnit.selectStatus == disableClass?click:$emit('updateflightls',pUnit,GET_ORG_BINDED_FLIGHT_LS&&GET_ORG_BINDED_FLIGHT_LS[index].legID?GET_ORG_BINDED_FLIGHT_LS[index].legID:null)">
                            <td>
                                <div>
                                    <div>
                                        <div >
                                            <label v-if="pUnit.obFlight" for="c" >
                                                

                                                {{pUnit.obFlight[0].flight.Bookingclass}} {{pUnit.fareType ? '- '+
                                                pUnit.fareType : null}}
                                            </label>
                                            
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div
                                        class="currency"
                                >{{pUnit.Pricing && pUnit.Pricing.Currency}}
                                </div>
                            </td>
                            <td>

                                <div class="value" v-if="searchObj.currency&&searchObj.currency.currency_code&&searchObj.currency.currency_code.code">
                                    {{pUnit.Pricing && pUnit.Pricing.AdultPrice.Total |
                                    amountformat(searchObj.currency.currency_code.code)}}
                                </div>
                            </td>
                           
                        </tr>

                        </tbody>

                    </table>

            

                </div>
               
                
                 <button @click="isShowMore==true?isShowMore=false:isShowMore=true" 
                        v-if="flights.length>noOfMaxFare && isShowMore==false" 
                        class="expander">
                     <img  src="@imgPath/img/svg/icons/down-arrow.svg" alt/>
                    {{$t('flightResults.cMLFlightResCard.showMore')}}
                 </button>
               
            </div>
        </div>
         <cConnectingFlightInfo v-if="toShowConnectingInfo && flights[0].obFlight.length>1" 
            :isResultPage="true"  :selectedFlight="flights" :flightObject="flights[0].obFlight"></cConnectingFlightInfo>
    </div>
                              <!-- <cMLFlightResCard
                                :legID="GET_ORG_BINDED_FLIGHT_LS[index].legID?GET_ORG_BINDED_FLIGHT_LS[index].legID:null"
                                :flightObj="flights[0].obFlight"
                                :totalFlightObj="flights"
                              /> -->
                            </div>
                          </transition-group>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div v-if="filterWatchList">
                    <cMLAllFilter
                      
                      :key="'mlfilter'+index"
                      :filterObWatList="Object.keys(filterWatchList[index]).length!=0?filterWatchList[index]:null"
                      :dispFilterTag="dispFilterLs[index]"
                      @cAllFilterOBFn="getAllFilteredList"
                      :isStopsForNonMyanmar="isStopsForNonMyanmar"
                      :class="{'mobile_ob':isShowFilter_MWA_OB}"
                    />
                  </div>-->
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <CCol col="4" v-if="bindedFlightLs"></CCol>

        <CCol col="12" v-if="
        bindedFlightLs
      "></CCol>
      </div>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

import { cloneData, scrollToTop, cloneDeep } from "../../../../../util/util.js";
import cEmptyFlightRes from "../../../../../components/result/cEmptyFlightRes";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import cSearch from "../../../../../components/search/cSearch";

import cFlightFooter from "../../../../../components/result/cFlightFooter";
import BaseConfiguration from "../../../../../config/base.js";
import cFlightResultCard from "../../../../../components/result/cFlightResultCard";

import cResultContentLoader from "../../../../../components/result/cResultContentLoader";
import Logger from "../../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../../config/API_DATA";

import router, {
  navigate,
  goBack,
  updateCurrRouteQuery,
  updateDataEdited
} from "../../../../../router/index";
import {
  SORT,
  ORDER,
  COMPONENT_NAME,
  PATHNAME,
  TRIP,
  TOAST_TYPE,
  ROUTER_PARAM,
  FILTER,
  BOUND_TYPE,
  FLIGHT_SELECTION_STATUS,
  DATE_TIME_FORMAT
} from "../../../../../util/constants";
import {
  getDiffBtwDates,
  differnceofDates,
  formatDate
} from "../../../../../util/date/dateFunctions";
import { mapGetters, mapActions } from "vuex";
import apiSearchWithoutMarkup from "../../../../../services/apiSearchWithoutMarkup";
import apiPricingSearch from "../../../../../services/apiPricingSearch.js";
import { oneWayRecommended, twoWayRecommended } from "../../chepestFlight.js";

import {
  handleJWT,
  getErrorAlertValue,
  groupBy,
  addClassToBody,
  OrderByList,
  removeClassBody,
  handleSessionExist
} from "../../../../../util/util";
import { is } from "vee-validate/dist/rules";
import cConnectingFlightInfo from "../../../../../components/result/cConnectingFlightInfo";
import cTextInputComponent from "../../../../../components/form/cTextInputComponent";
import { ValidationProvider } from "vee-validate";
import cMLFlightResCard from "../../../../../components/MLCity/result/cMLFlightResCard";

export default {
  name: COMPONENT_NAME.FLIGHTRESULTS,
  components: {
    cSearch,

    cFlightFooter,
    cFlightResultCard,
    ContentLoader,

    cEmptyFlightRes,
    cConnectingFlightInfo,
    cTextInputComponent,
    ValidationProvider,
    cMLFlightResCard
  },
  data: () => ({
    flightCount: 0,

    isDebug: BaseConfiguration.isDebug,
    defaultALImg: BaseConfiguration.defaultALImg,
    isShowMore: false,
    toShowConnectingInfo: false,
    toShowConnectingIBInfo: false,

    isShowFilter_MWA_OB: false,
    isShowFilter_MWA_IB: false,
    selFlight: {
      ob: null,
      ib: null
    },
    selIbSortVal: null,
    selObSortVal: null,
    filterObWatchList: null,
    filterIbWatchList: null,
    isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
    noOfMaxFare: BaseConfiguration.maxFareList,
    relevantOBCount: 0,
    relevantIBCount: 0,
    sessionId: null,
    alertValue: null,
    routesObj: null,
    searchObj: null,
    isModifySearch: false,
    obStops: [],
    ibStops: [],
    flightAlert: null,
    isLoading: true,
    noClass: FLIGHT_SELECTION_STATUS.noClass,
    selectedClass: FLIGHT_SELECTION_STATUS.selected,
    selectableClass: FLIGHT_SELECTION_STATUS.selectable,
    disableClass: FLIGHT_SELECTION_STATUS.disable,
    showAlert: false,
    cheapestLs: [],
    isShowFilter_MWA: false, //MWA-MobileWebApp, for small devices. Handling responsive web page
    obFilterTag: [],
    ibFilterTag: [],
    selIbFilterItems: null,
    selObFilterItems: null,
    isMobile: BaseConfiguration.isMobile,
    passCode: null,
    bindedFlightLsForML: [],
    // bindedFlightLs:[]
  }),

  methods: {
    ...mapActions("sPaxPage", {
      CLEAR_PAX_STORE: "CLEAR_PAX_STORE"
    }),
    ...mapActions("sCSearch", {
      SET_SEARCH_OBJ: "SET_SEARCH_OBJ"
    }),
    ...mapActions("sMLResult", {
      CLEAR_ML_RESULT_STORE: "CLEAR_ML_RESULT_STORE"
    }),

    ...mapActions("sResult", {
      CLEAR_RESULT_STORE: "CLEAR_RESULT_STORE",
      SET_CHEAPESTLS: "SET_CHEAPESTLS",
      SET_ORG_BINDED_FLIGHT_LS: "SET_ORG_BINDED_FLIGHT_LS",
      SET_IB_SEL_SORT_OBJ: "SET_IB_SEL_SORT_OBJ",
      SET_OB_SEL_SORT_OBJ: "SET_OB_SEL_SORT_OBJ",
      SET_OB_FILTER_DATA: "SET_OB_FILTER_DATA",
      SET_IB_FILTER_DATA: "SET_IB_FILTER_DATA",
      SET_OB_FLIGHT_OBJ: "SET_OB_FLIGHT_OBJ",
      SET_IB_FLIGHT_OBJ: "SET_IB_FLIGHT_OBJ",
      SET_SEL_SORT_OBJ: "SET_SEL_SORT_OBJ",

      SET_SEL_PRICING_OBJ: "SET_SEL_PRICING_OBJ",
      SET_SEL_FLI_FRM_PRIC: "SET_SEL_FLI_FRM_PRIC",
      SET_AIRLINES: "SET_AIRLINES",
      SET_CURRENCY: "SET_CURRENCY",
      SET_SEARCH_PRICING_REQ: "SET_SEARCH_PRICING_REQ",
      SET_SEARCH_RES: "SET_SEARCH_RES",
      SET_BINDED_FLIGHT_LS: "SET_BINDED_FLIGHT_LS",
      SET_SELFLIGHT_FOR_FOOTER: "SET_SELFLIGHT_FOR_FOOTER"
    }),

    ///to get date object in particular format

    dateFormatInTooltip(pDate) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("formatDate");
        if (pDate != null) {
          retValue = this.$options.filters.formatDate(
            pDate,

            DATE_TIME_FORMAT.DAY_DATE_MONTH
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_FLIGHTRESULTCARD,
          "error in dateFormatInTooltip",
          err.toString(),
          "dateFormatInTooltip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///to get no of days tooltip
    noOfDaysTooltip(pNoofDays) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("noOfDaysTooltip");
        if (pNoofDays) {
          if (pNoofDays == 1) {
            retValue = "Flight lands the next day";
          } else {
            pNoofDays = pNoofDays.replace("+", "");
            retValue = "Flight lands after " + pNoofDays + " days";
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_FLIGHTRESULTCARD,
          "error in noOfDaysTooltip",
          err.toString(),
          "noOfDaysTooltip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///on Booking the combined flights

    onBooking(pFlight) {
      try {
        if (BaseConfiguration.isDebug) console.log("onBooking");
        if (pFlight.length == 1) {
          this.assignObSelFlight(pFlight[0]);
        } else {
          for (let i = 0; i < pFlight.length; i++) {
            if (pFlight[i].obFlight) {
              this.assignObSelFlight(pFlight[i]);
            } else if (pFlight[i].ibFlight) {
              this.assignIbSelFlight(pFlight[i]);
            }
          }
        }
        if (this.searchObj.trip == TRIP.ONE_WAY && this.selFlight.ob != null) {
          this.OnContinue();
        } else if (
          this.searchObj.trip == TRIP.ROUND_TRIP &&
          this.selFlight.ob != null &&
          this.selFlight.ib != null
        ) {
          this.OnContinue();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in onBooking",
          err.toString(),
          "onBooking",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    /// to prevent the click functionality
    click(e) {
      e.preventDefault();
    },

    ///scroll into view
    scrollToElement(pRef) {
      var el = null;
      if (pRef == "scrollToReturn") {
        el = this.$refs.scrollToReturn;
      } else {
        el = this.$refs.scrollToDeparture;
      }

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },

    //to get class for airline card
    getClassforALCard(pFlightObj) {
      let retValue = false;
      try {
        if (!retValue && pFlightObj) {
          for (let i = 0; i < pFlightObj.length; i++) {
            if (
              pFlightObj[i].selectStatus == FLIGHT_SELECTION_STATUS.selected
            ) {
              retValue = true;
              break;
            } else {
              retValue = false;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in getClassforALCard",
          err.toString(),
          "getClassforALCard",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //sorted list emit from cSortDropDown  based on property value
    getObSortedVal(pselObSortVal) {
      try {
        this.selObSortVal = pselObSortVal;

        this.SET_OB_SEL_SORT_OBJ(this.selObSortVal);
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.FLIGHTRESULTS,
          "error while emitting from CSortDropDown",
          err.toString(),
          "getObSortedVal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //sorted list emit from cIbSortDropDown  based on property value
    getIbSortedVal(pselIbSortVal) {
      try {
        this.selIbSortVal = pselIbSortVal;
        this.SET_IB_SEL_SORT_OBJ(this.selIbSortVal);
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.FLIGHTRESULTS,
          "error while emitting from CSortDropDown",
          err.toString(),
          "getSortedList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //to show or hide search component
    isToggleCSearch() {
      try {
        if (BaseConfiguration.isDebug) console.log("isToggleCSearch");

        this.isModifySearch = !this.isModifySearch;
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.FLIGHTRESULTS,
          "error while modifing search",
          err.toString(),
          "isToggleCSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get list of search results from api
    async getSearchResponse(pSearchObj,pPassCode) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getSearchResponse");

        let getSearchRequest = apiSearchWithoutMarkup.buildRequest(pSearchObj,pPassCode);

        if (getSearchRequest) {
          let getSearchResponse = await apiSearchWithoutMarkup.getResponse(
            getSearchRequest
          );

          if (VALIDATE_SUCCESS_RES(getSearchResponse)) {
            this.isLoading = false;
            this.SET_SEARCH_RES(getSearchResponse.data.data);
            retValue = getSearchResponse.data.data;
          } else {
            let error = getErrorMessage(getSearchResponse);
            let isSessionExpired = handleSessionExist(getSearchResponse.data);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.FLIGHTRESULTS,
          "error in getting response from get search result response API",
          err.toString(),
          "getSearchResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //nav to pax info page
    goToPaxInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("goToPaxInfo");
        if (this.$router.currentRoute.path == PATHNAME.FLIGHTRESULTS) {
          navigate(PATHNAME.PAXPAGE, this.$router.currentRoute.query);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in goToPaxInfo",
          err.toString(),
          "goToPaxInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //to disable continue button
    toDisableContinueButton() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toDisableContinueButton");
        if (this.searchObj && this.searchObj.trip == TRIP.ROUND_TRIP) {
          if (
            this.selFlight &&
            this.selFlight.ob != null &&
            this.selFlight.ib != null
          ) {
            retValue = false;
          } else {
            retValue = true;
          }
        } else if (
          this.selFlight &&
          this.searchObj &&
          this.searchObj.trip == TRIP.ONE_WAY
        ) {
          if (this.selFlight.ob != null) {
            retValue = false;
          } else {
            retValue = true;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in toDisableContinueButton",
          err.toString(),
          "toDisableContinueButton",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///check availability of flights based on trip
    checkFlightsforTrip(pSearchObj, pSearchResult) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("checkFlightsforTrip");
        if (pSearchObj.trip == TRIP.ONE_WAY) {
          if (
            pSearchResult &&
            pSearchResult.flight_results &&
            pSearchResult.flight_results.obflights &&
            pSearchResult.flight_results.obflights.length > 0
          ) {
            retValue = false;
          } else {
            retValue = true;
          }
        } else if (pSearchObj.trip == TRIP.ROUND_TRIP) {
          if (
            pSearchResult &&
            pSearchResult.flight_results &&
            pSearchResult.flight_results.obflights &&
            pSearchResult.flight_results.obflights.length > 0 &&
            pSearchResult.flight_results.ibflights &&
            pSearchResult.flight_results.ibflights.length > 0
          ) {
            retValue = false;
          } else {
            retValue = true;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in checkFlightsforTrip",
          err.toString(),
          "checkFlightsforTrip",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //Adding selectStatus, pricegroup_code, Via_Obj, TotalDuration, no_of_days, no_of_stops, no_of_ViaObj
    assigningFlightProp(pFlight, isOb) {
      let flightObj;
      try {
        if (BaseConfiguration.isDebug) console.log("assigningFlightProp");

        flightObj = isOb ? pFlight.obFlight : pFlight.ibFlight;
        pFlight["selectStatus"] = FLIGHT_SELECTION_STATUS.noClass;
        pFlight["isMaxFare"] = false;
        let depdate = this.$options.filters.formatDate(
          flightObj[0].flight.DepDate,
          "DDMMMYYYYHHMM"
        );

        pFlight["pricegroup_code"] =
          flightObj[0].flight.FlightNo +
          flightObj[0].flight.opAirline +
          flightObj[0].flight.DepAirport +
          depdate;
        pFlight.pricegroup_code = pFlight.pricegroup_code
          .toUpperCase()
          .replace("-", "");

        flightObj[0].flight["Via_Obj"] = "";
        flightObj[0].flight["TotalDuration"] = 0;
        flightObj[0].flight["no_of_days"] = 0;
        flightObj[0].flight["no_of_stops"] = {
          code: 0,
          name: null,
          status: 0,
          by: "default"
        };
        flightObj[0].flight["no_of_viaObj"] = {
          code: 0,
          name: null,
          status: 1,
          by: "default"
        };

        flightObj[0].flight.no_of_stops.name =
          flightObj.length - 1 == 0
            ? this.$t("flightResults.nonstop")
            : flightObj.length - 1 == 1
            ? flightObj.length - 1 + " " + this.$t("flightResults.stop")
            : flightObj.length - 1 > 1
            ? flightObj.length - 1 + " " + this.$t("flightResults.stops")
            : null;
        flightObj[0].flight.no_of_stops.code = flightObj.length;

        this.obStops.push(flightObj[0].flight.no_of_stops);
        this.ibStops.push(flightObj[0].flight.no_of_stops);

        flightObj[0].flight.no_of_days =
          differnceofDates(
            flightObj[flightObj.length - 1].flight.ArrDate,
            flightObj[0].flight.DepDate
          ) != 0
            ? "+" +
              differnceofDates(
                flightObj[flightObj.length - 1].flight.ArrDate,
                flightObj[0].flight.DepDate
              )
            : null;
        for (let j = 0; j < flightObj.length; j++) {
          flightObj[0].flight.TotalDuration +=
            flightObj[j].flight.DurationInMin;
          if (flightObj[j].transit.transittime != "") {
            flightObj[0].flight.TotalDuration +=
              flightObj[j].transit.transittime;
          }

          if (
            flightObj[j].flight.via &&
            flightObj[j].flight.via != null &&
            flightObj[j].flight.via.text &&
            flightObj[j].flight.via.text != null
          ) {
            if (j == 0) {
              flightObj[0].flight.Via_Obj += flightObj[j].flight.via.text;
            } else {
              flightObj[0].flight.Via_Obj +=
                "," + flightObj[j].flight.via.text.replace("Via", "");
            }
          }
        }
        if (
          flightObj[0].flight.Via_Obj == null ||
          flightObj[0].flight.Via_Obj == ""
        ) {
          flightObj[0].flight.Via_Obj = this.$t("flightResults.nonstop");
        }

        if (flightObj.length == 1) {
          if (flightObj[0].flight.Via_Obj != "Non-Stop") {
            flightObj[0].flight.no_of_viaObj.code =
              flightObj[0].flight.Via_Obj.split(",").length + 1;
            flightObj[0].flight.no_of_viaObj.name =
              flightObj[0].flight.Via_Obj.split(",").length + " " + "Stop";
            flightObj[0].flight.no_of_viaObj.status = 0;
            flightObj[0].flight.no_of_viaObj.by = "default";
          } else {
            flightObj[0].flight.no_of_viaObj.code = flightObj[0].flight.Via_Obj.split(
              ","
            ).length;
            flightObj[0].flight.no_of_viaObj.name = "Non-Stop";
            flightObj[0].flight.no_of_viaObj.status = 0;
            flightObj[0].flight.no_of_viaObj.by = "default";
          }
        } else if (flightObj.length > 1) {
          flightObj[0].flight.no_of_viaObj = flightObj[0].flight.no_of_stops;
        }

        if (isOb) pFlight.obFlight = flightObj;
        else pFlight.ibFlight = flightObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in assigningFlightProp",
          err.toString(),
          "assigningFlightProp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return pFlight;
    },
    //Adding selectStatus, pricegroup_code, Via_Obj, TotalDuration, no_of_days, no_of_stops, no_of_ViaObj
    assigningFlightPropForML(pFlight) {
      let flightObj;
      try {
        if (BaseConfiguration.isDebug) console.log("assigningFlightPropForML");
        flightObj = pFlight.obFlight;
        if (pFlight.obFlight.length > 1) {
          pFlight["toShowConnectingInfo"] = false;
        }
        pFlight["selectStatus"] = FLIGHT_SELECTION_STATUS.noClass;
        pFlight["isMaxFare"] = false;
        let depdate = this.$options.filters.formatDate(
          flightObj[0].flight.DepDate,
          "DDMMMYYYYHHMM"
        );

        pFlight["pricegroup_code"] =
          flightObj[0].flight.FlightNo +
          flightObj[0].flight.opAirline +
          flightObj[0].flight.DepAirport +
          depdate;
        pFlight.pricegroup_code = pFlight.pricegroup_code
          .toUpperCase()
          .replace("-", "");
        // flightObj[0].flight["Via_Obj"] =
        //   flightObj[0].flight.via != null &&
        //   flightObj[0].flight.via.text &&
        //   flightObj[0].flight.via.text != null
        //     ? flightObj[0].flight.via.text
        //     : this.$t('flightResults.nonstop');
        flightObj[0].flight["Via_Obj"] = "";
        flightObj[0].flight["TotalDuration"] = 0;
        flightObj[0].flight["no_of_days"] = 0;
        flightObj[0].flight["no_of_stops"] = {
          code: 0,
          name: null,
          status: 0,
          by: "default"
        };
        flightObj[0].flight["no_of_viaObj"] = {
          code: 0,
          name: null,
          status: 1,
          by: "default"
        };

        flightObj[0].flight.no_of_stops.name =
          flightObj.length - 1 == 0
            ? this.$t("flightResults.nonstop")
            : flightObj.length - 1 == 1
            ? flightObj.length - 1 + " " + this.$t("flightResults.stop")
            : flightObj.length - 1 > 1
            ? flightObj.length - 1 + " " + this.$t("flightResults.stops")
            : null;
        flightObj[0].flight.no_of_stops.code = flightObj.length;

        this.obStops.push(flightObj[0].flight.no_of_stops);
        this.ibStops.push(flightObj[0].flight.no_of_stops);

        // flightObj[0].flight.no_of_days =
        //   getDiffBtwDates(
        //     new Date(flightObj[flightObj.length - 1].flight.ArrDate),
        //     new Date(flightObj[0].flight.DepDate),

        //     "days"
        //   ) != 0
        //     ? "+" +
        //       getDiffBtwDates(
        //         new Date(flightObj[flightObj.length - 1].flight.ArrDate),
        //         new Date(flightObj[0].flight.DepDate),

        //         "days"
        //       )
        //     : null;
        flightObj[0].flight.no_of_days =
          differnceofDates(
            flightObj[flightObj.length - 1].flight.ArrDate,
            flightObj[0].flight.DepDate
          ) != 0
            ? "+" +
              differnceofDates(
                flightObj[flightObj.length - 1].flight.ArrDate,
                flightObj[0].flight.DepDate
              )
            : null;
        for (let j = 0; j < flightObj.length; j++) {
          flightObj[0].flight.TotalDuration +=
            flightObj[j].flight.DurationInMin;
          if (flightObj[j].transit.transittime != "") {
            flightObj[0].flight.TotalDuration +=
              flightObj[j].transit.transittime;
          }

          if (
            flightObj[j].flight.via &&
            flightObj[j].flight.via != null &&
            flightObj[j].flight.via.text &&
            flightObj[j].flight.via.text != null
          ) {
            if (j == 0) {
              flightObj[0].flight.Via_Obj += flightObj[j].flight.via.text;
            } else {
              flightObj[0].flight.Via_Obj +=
                "," + flightObj[j].flight.via.text.replace("Via", "");
            }
          }
        }
        if (
          flightObj[0].flight.Via_Obj == null ||
          flightObj[0].flight.Via_Obj == ""
        ) {
          flightObj[0].flight.Via_Obj = this.$t("flightResults.nonstop");
        }
        if (flightObj.length == 1) {
          if (flightObj[0].flight.Via_Obj != "Non-Stop") {
            flightObj[0].flight.no_of_viaObj.code =
              flightObj[0].flight.Via_Obj.split(",").length + 1;
            flightObj[0].flight.no_of_viaObj.name =
              flightObj[0].flight.Via_Obj.split(",").length +
              " " +
              this.$t("flightResults.stop");
            flightObj[0].flight.no_of_viaObj.status = 0;
            flightObj[0].flight.no_of_viaObj.by = "default";
          } else {
            flightObj[0].flight.no_of_viaObj.code = flightObj[0].flight.Via_Obj.split(
              ","
            ).length;
            flightObj[0].flight.no_of_viaObj.name = this.$t(
              "flightResults.nonstop"
            );
            flightObj[0].flight.no_of_viaObj.status = 0;
            flightObj[0].flight.no_of_viaObj.by = "default";
          }
        } else if (flightObj.length > 1) {
          flightObj[0].flight.no_of_viaObj = flightObj[0].flight.no_of_stops;
        }

        pFlight.obFlight = flightObj;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ML_FLIGHTRESULTS,
          "error in assigningFlightPropForML",
          err.toString(),
          "assigningFlightPropForML",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return pFlight;
    },
    ///to get the binded list of flights from original response
    getCombinedList(res, pSearchObj) {
      let retValue = {
        ob: null,
        ib: null
      };
      let flightTofilterList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getCombinedList");
        if (!res) {
          res = this.GET_SEARCH_RES;
        }
        if (
          res.obflights &&
          res.obflights.length != 0
        ) {
          let obLIst = res.obflights;

          for (let index = 0; index < obLIst.length; index++) {
            const flightsObj = obLIst[index];
            var viaObLs = [];
            flightsObj = this.assigningFlightProp(flightsObj, true);
            flightTofilterList.push(flightsObj);
          }
          retValue.ob = groupBy(flightTofilterList, "pricegroup_code");
        }
        if (
          res.ibflights &&
          res.ibflights.length != 0
        ) {
          let ibLIst = res.ibflights;
          flightTofilterList = [];
          for (let index = 0; index < ibLIst.length; index++) {
            const flightsObj = ibLIst[index];
            var viaIbLs = [];
            flightsObj = this.assigningFlightProp(flightsObj, false);
            flightTofilterList.push(flightsObj);
          }
          retValue.ib = groupBy(flightTofilterList, "pricegroup_code");
        }

        retValue = JSON.parse(JSON.stringify(retValue));
        var orgBindedLs = cloneData(retValue);
        this.SET_ORG_BINDED_FLIGHT_LS(orgBindedLs);
        if (
          this.searchStoreObj != null &&
          this.searchStoreObj.trip == TRIP.ROUND_TRIP &&
          res.obflights.length != 0 &&
          res.ibflights.length != 0
        ) {
          this.SET_BINDED_FLIGHT_LS(orgBindedLs);
        } else if (
          this.searchStoreObj != null &&
          this.searchStoreObj.trip == TRIP.ONE_WAY &&
          res.obflights.length != 0
        ) {
          this.SET_BINDED_FLIGHT_LS(orgBindedLs);
        }
        this.assignBindedFlights(retValue, pSearchObj);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in getCombinedList",
          err.toString(),
          "getCombinedList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///to get the binded list of flights from original response
    getCombinedListForML(res, pSearchObj) {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getCombinedListForML");
        if (!res) {
          res = this.GET_SEARCH_RES;
        }
        if (res.length != 0) {
          for (let index = 0; index < res.length; index++) {
            var from = null;
            var date = null;
            var to = null;
            var flightsObj = [];
            var flights = null;

            for (var j in res[index]) {
              if (
                j == "obflights" &&
                res[index][j].length != 0
              ) {
                flightsObj = res[index][j];
              }
              if (j == "from") {
                from = res[index][j];
              }
              if (j == "to") {
                to = res[index][j];
              }
              if (j == "date") {
                date = res[index][j];
              }
            }
            let flightTofilterList = [];
            this.flightCount += flightsObj.length;
            if (flightsObj.length != 0) {
              for (let i = 0; i < flightsObj.length; i++) {
                flights = this.assigningFlightPropForML(flightsObj[i]);
                flightTofilterList.push(flights);
              }
              retValue.push(groupBy(flightTofilterList, "pricegroup_code"));
              retValue[index] = JSON.parse(JSON.stringify(retValue[index]));
            } else {
              retValue.push({});
            }
            retValue[index].from = from;
            retValue[index].to = to;
            retValue[index].date = date;
            retValue[index].legID = index + 1;
          }
        }

        var orgBindedLs = cloneData(retValue);
        this.SET_ORG_BINDED_FLIGHT_LS(orgBindedLs);

        this.SET_BINDED_FLIGHT_LS(orgBindedLs);

        this.assignBindedFlights(retValue, pSearchObj);
        // console.log(JSON.stringify(retValue));
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ML_FLIGHTRESULTS,
          "error in getCombinedListForML",
          err.toString(),
          "getCombinedListForML",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getBindedLsForMl(bindFilterLs) {
      try {
        if (BaseConfiguration.isDebug) console.log("getBindedLsForMl");
       let formattedList = [];

        for(let i=0;i<bindFilterLs.length;i++){
            if(Object.keys(bindFilterLs[i]).length>4){
                let list=[];
            for(let j=0;j<Object.keys(bindFilterLs[i]).length;j++){
                let key=Object.keys(bindFilterLs[i])[j];
                  let subList=[];
                if (
                     key != "from" &&
                        key != "to" &&
                        key != "date" &&
                        key != "legID" 
                      ) {
                          
                        for(let k=0;k<bindFilterLs[i][key].length;k++){
                           subList.push(bindFilterLs[i][key][k]);
                        }
                      list.push(subList);

                      }
            }
             formattedList.push(list);
            }else{
                formattedList.push([]);
            }
        }
                   
                  
       

        return formattedList;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in getBindedLsForMl",
          err.toString(),
          "getBindedLsForMl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignBindedFlights(pBindedFlights, pSearchObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignBindedFlights");
        if (pSearchObj.trip == 3) {
          this.bindedFlightLsForML = this.getBindedLsForMl(pBindedFlights);
        } else {
          this.bindedFlightLs.ob = pBindedFlights.ob;
          this.bindedFlightLs.ib = pBindedFlights.ib;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in assignBindedFlights",
          err.toString(),
          "assignBindedFlights",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    /// search functionality on modify search
    async onSearch(pSearchObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSearch");

        // if (pSearchObj.trip == 3) {
        //   this.CLEAR_ML_RESULT_STORE();
        //   navigate(PATHNAME.ML_FLIGHTRESULTS);
        // } else {
        this.isModifySearch = false;
        this.bindedFlightLs.ob = null;
        this.bindedFlightLs.ib = null;
        this.bindedFlightLs = [];
        this.isLoading = true;

        this.CLEAR_RESULT_STORE();
        this.SET_SEARCH_OBJ(pSearchObj);
        this.formattingFlightRes();
        // }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in modifySearch",
          err.toString(),
          "searching",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    updateRouteUrl(pSessionId) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateRouteUrl");

        if (pSessionId) {
          let param = {};
          param[ROUTER_PARAM.SESSION_ID] = pSessionId;

          updateCurrRouteQuery(param);
        } else {
          throw "invlaid session id";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          PATHNAME.FLIGHTRESULTS,
          "error in updateRouteUrl",
          err.toString(),
          "updateRouteUrl",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///functionality to show toast
    showToastForFlights(pBindedFlightLs, pSearchObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("showToastForFlights");

        this.showToast(null, TOAST_TYPE.CLEAR);
        let toastAction = {
          text: this.$t("flightResults.modifySearch"),
          onClick: () => {
            this.isModifySearch = true;
            scrollToTop();
          }
        };
        if (pBindedFlightLs) {
          if (
            pSearchObj &&
            pSearchObj.trip == TRIP.ONE_WAY &&
            pBindedFlightLs.ob
          ) {
            this.showToast(
              Object.keys(pBindedFlightLs.ob).length +
                this.$t("flightResults.flightsAvailable"),
              TOAST_TYPE.SUCCESS,
              1000,
              null
            );
          } else if (
            pSearchObj &&
            pSearchObj.trip == TRIP.ROUND_TRIP &&
            pBindedFlightLs.ob &&
            pBindedFlightLs.ib
          ) {
            this.showToast(
              Object.keys(pBindedFlightLs.ob).length +
                Object.keys(pBindedFlightLs.ib).length +
                this.$t("flightResults.flightsAvailable"),
              TOAST_TYPE.SUCCESS,
              1000,
              null
            );
          } else if (
            !(pSearchObj && pSearchObj.trip == TRIP.ROUND_TRIP
              ? pBindedFlightLs.ob && pBindedFlightLs.ib
              : pBindedFlightLs.ob)
          ) {
            this.showToast(
              this.$t("flightResults.noFlights"),
              TOAST_TYPE.ERROR,
              2000,
              toastAction
            );
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in showToastForFlights",
          err.toString(),
          "showToastForFlights",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    /// handling the response when the page is created
    async formattingFlightRes() {
      let retSearchResult = null;
      try {
        if (BaseConfiguration.isDebug) console.log("formattingFlightRes");
        let bindedFlights;
        if (this.searchStoreObj != null) {
          this.searchObj = cloneDeep(this.searchStoreObj);
          this.showToast("", TOAST_TYPE.CLEAR, null, null);

          if (this.sStoreBindedLs == null) {
            this.showToast(
              this.$t("flightResults.searching"),
              TOAST_TYPE.INFO,
              null,
              null
            );
            retSearchResult = await this.getSearchResponse(this.searchObj,this.passCode);

            // if (retSearchResult && retSearchResult.sessionId) {
            //   this.updateRouteUrl(retSearchResult.sessionId);
            // }
            if (retSearchResult) {
            //   this.SET_AIRLINES(retSearchResult.airlines);
            //   this.SET_CURRENCY(retSearchResult.currency);
              if (this.searchObj.trip == 3) {
                bindedFlights = this.getCombinedListForML(
                  retSearchResult,
                  this.searchObj
                );
              } else {
                bindedFlights = this.getCombinedList(
                  retSearchResult,
                  this.searchObj
                );
              }
            }
            this.showAlert = this.checkFlightsforTrip(
              this.searchObj,
              retSearchResult
            );

            this.showToastForFlights(bindedFlights, this.searchObj);
          } else {
            bindedFlights = this.sStoreBindedLs;
            this.isLoading = false;
          }
        } //invalid search obj
        else {
          this.searchObj = null;
        } //need to handle

        if (BaseConfiguration.isDebug) console.log(bindedFlights);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TEST_FLIGH_RESULTS,
          "error in formattingFlightRes",
          err.toString(),
          "formattingFlightRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
  mounted() {
    this.$root.$emit("toggle-fixed-header", true);
    this.$root.$emit("toggle-sidebar-minimize");
  },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.$root.$emit("toggle-fixed-header", true);
      this.$root.$emit("toggle-sidebar-minimize");
      //   await this.formattingFlightRes();
      this.searchObj = cloneDeep(this.searchStoreObj);

    //   await this.onSearch(this.searchObj);
    } catch (err) {
      let body = Logger.buildRequest(
        PATHNAME.FLIGHTRESULTS,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.FLIGHTRESULTS);
  },

  beforeDestroy() {
    this.$root.$emit("toggle-sidebar-minimize", true);

    removeClassBody();
  },

  computed: {
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    },
         ...mapGetters("sMLResult", {
      GET_ML_AIRLINES: 'GET_ML_AIRLINES',
     
    }),
    ...mapGetters("sCSearch", {
      searchStoreObj: "GET_SEARCH_OBJ"
    }),
    ...mapGetters("sCSearch", {
      sRoutesObj: "GET_ROUTES_OBJ"
    }),
    ...mapGetters("sResult", {
      GET_ORG_BINDED_FLIGHT_LS: "GET_ORG_BINDED_FLIGHT_LS",
      GET_SEARCH_RES: "GET_SEARCH_RES",
      sStoreBindedLs: "GET_BINDED_FLIGHT_LS",
      GET_AIRLINES: "GET_AIRLINES",
    
    }),

    bindedFlightLs: {
      get: function() {
        let filteredLs = {
          ob: null,
          ib: null
        };

        if (this.GET_ORG_BINDED_FLIGHT_LS != null) {
          let bindFilterLs = this.GET_ORG_BINDED_FLIGHT_LS;
        }

        return filteredLs;
      },

      set: function() {}
    },

  
  }
};
</script>
<style scoped>
.flip-list-enter-active,
.flip-list-leave-active {
  transition: all 1s;
}
.flip-list-enter, .flip-list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateY(30px);
}

.selectable {
  background-color: red;
}

.selected {
  background-color: green;
}

.disable {
  background-color: #d3d3d359;

  /*background-color: lightgray;*/
}

.disable-flight {
  background-color: grey;
}
/* 
    .selected-flight {
      background-color:linen;
     }  */

.no-class {
  background-color: white;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateY(30px);
}

.bounce-enter-active {
  animation: bounce-in 0.6s;
}

.bounce-leave-active {
  animation: bounce-in 0.3s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translate(0%, -130%);
  }

  100% {
    transform: translate(0px, 0%);
  }
  /*0% {*/
  /*    transform: scale(0);*/
  /*}*/
  /*50% {*/
  /*    transform: scale(1.1);*/
  /*}*/
  /*100% {*/
  /*    transform: scale(1);*/
  /*}*/
}
</style>
